import { withStyles } from '@material-ui/core';

import PageTitle from './component';
import styles from './styles';

export default withStyles(styles)(PageTitle);
